module.exports = __webpack_public_path__ + "static/media/tutoriales_tienda.416f86fc.svg";